import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import ClearButton from '@atlassian/jira-filters/src/ui/filters/clear-button/index.tsx';
import { NonCriticalErrorBoundary } from '../../common/utils/non-critical-error-boundary';
import { useHasAppliedFilters } from '../../controllers/top-filter';
import EpicFilter from './epic-filter';
import IssueTypeFilter from './issue-type-filter';

const Filters = () => {
	const [hasAppliedFilters, actions] = useHasAppliedFilters();
	return (
		<FiltersContainer>
			<NonCriticalErrorBoundary fallback="flag" eventLocation="issueTypeFilter">
				<IssueTypeFilter />
			</NonCriticalErrorBoundary>
			<NonCriticalErrorBoundary fallback="flag" eventLocation="epicFilter">
				<EpicFilter />
			</NonCriticalErrorBoundary>
			{hasAppliedFilters && <ClearButton onClick={actions.resetAllFilters} />}
		</FiltersContainer>
	);
};

export default Filters;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FiltersContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	marginTop: token('space.200', '16px'),
});
